
function SdSelectContactCtrl(TranslationService, StoreService) {
    var ctrl = this;

    ctrl.translation = TranslationService.getActiveTranslation();

    ctrl.options = [
        { ContactID: 'B11', ContactName: 'AEROTEC' },
        { ContactID: 'B25', ContactName: 'KLEBER' }

    ];


    ctrl.$onInit = function () {
        ctrl.loaded = false;

        StoreService.getContacts().then(
            function (response) {
                ctrl.options = response.data;
        });
    };

    //ctrl.titleClass = function (title) {
    //    if (title == 'Principal') {
    //        return 'title-principal';
    //    }
    //    else {
    //        return 'alternatives';
    //    }
    //}

    //ctrl.statusOfId = function (id) {
    //    if (id == ctrl.statusId) {
    //        return 'Status' + id;
    //    }
    //    else {
    //        return '';
    //    }
    //};

    ctrl.selectOption = function (option, event) {
        ctrl.contactId = option.ContactID;
        ctrl.contactName = option.ContactName;
        //ctrl.contact = option;
    };
}

SdSelectContactCtrl.$inject = ['TranslationService', 'StoreService'];

seedWebApp.component('sdSelectContact', {
    controller: SdSelectContactCtrl,
    bindings: {
        contactId: '=',
        contactName: '=',
        contact: '=',
        disabled: '<',
    },
    templateUrl: '/SPA/Components/sd-select-contact.html'
});